import React from "react";
import { Counterparty } from "@common/types/counterparty";
import { ConfirmationModal } from "@design-system/Modal/ConfirmationModal";

interface Props {
    show: boolean;
    counterparty: Pick<Counterparty, "name">;
    onConfirm: () => Promise<unknown>;
    onHide: () => void;
}

export const CounterpartyLinkedToBillsOrInvoicesModal: React.FC<Props> = ({
    show,
    counterparty,
    onConfirm,
    onHide,
}) => (
    <ConfirmationModal
        show={show}
        onHide={onHide}
        title="Counterparty is used by bills or invoices"
        question={
            <p className="mb-0">
                <strong className="font-weight-medium">
                    {counterparty.name}
                </strong>{" "}
                is linked to one or more bills or invoices, so it can&apos;t be
                deleted. You can archive{" "}
                <strong className="font-weight-medium">
                    {counterparty.name}
                </strong>{" "}
                instead - it will remain on the existing bills/invoices but
                won&apos;t be assignable to new ones.
            </p>
        }
        yes="Archive counterparty"
        no="Cancel"
        onConfirm={onConfirm}
        onReject={onHide}
    />
);
